<script setup lang="ts">
import { TriangleAlert } from 'lucide-vue-next'
const { t } = useI18n()

defineProps<{
  isOpen: boolean
  handleClose: (isOpen: boolean) => void
  isComplete: boolean
}>()

const emit = defineEmits<{
  (e: 'onSaveAndQuit'): void
  (e: 'onExit'): void
}>()
</script>

<template>
  <BaseModal :is-open="isOpen" size="lg" :show-footer="false" content-class="pt-4!" @close="handleClose(false)">
    <div class="pt-4 flex w-full flex-row justify-center">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100">
        <TriangleAlert class="h-6 w-6 text-yellow-600" />
      </div>
    </div>

    <p class="mt-5 text-center font-semibold">
      {{ t('pages.marketingFlow.marketingFlowEditPage.exitWithChangesConfirmation') }}
    </p>

    <p class="mb-5 mt-2 text-center text-sm text-foreground-secondary">
      {{
        isComplete
          ? t('pages.marketingFlow.marketingFlowEditPage.exitWithChangesDisclaimer')
          : t('pages.marketingFlow.marketingFlowEditPage.exitWithIncompleteChangesDisclaimer')
      }}
    </p>

    <div class="flex w-full flex-row justify-center gap-3">
      <Button variant="outline" class="flex-1" @click="emit('onExit')">
        <span class="text-foreground">
          {{ t('pages.marketingFlow.marketingFlowEditPage.exitWithChangesButton') }}
        </span>
      </Button>

      <Button variant="default-primary" class="flex-1" :disabled="!isComplete" @click="emit('onSaveAndQuit')">
        {{ t('pages.marketingFlow.marketingFlowEditPage.saveAndQuitButton') }}
      </Button>
    </div>
  </BaseModal>
</template>
